"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customCssWrapper = void 0;
const customCssWrapper = (css, customCss) => (Object.assign(Object.assign({}, css), { styles: `${css.styles}${customCss === null || customCss === void 0 ? void 0 : customCss.styles}` }));
exports.customCssWrapper = customCssWrapper;
